import { AfterViewInit, Directive, ElementRef, NgZone, OnDestroy } from '@angular/core';

@Directive({
  selector: '[cxDragScroll]',
})
export class DragScrollDirective implements AfterViewInit, OnDestroy {
  private scrollContainer: HTMLElement | null = null;
  private isDragging = false;
  private startX = 0;
  private scrollLeft = 0;
  private hasMoved = false;

  private readonly DRAG_THRESHOLD = 5;

  private onMouseDown = (e: MouseEvent) => this.handleMouseDown(e);
  private onMouseMove = (e: MouseEvent) => this.handleMouseMove(e);
  private onMouseUp = () => this.handleMouseUp();
  private onClickCapture = (e: MouseEvent) => this.handleClickCapture(e);

  constructor(
    private el: ElementRef<HTMLElement>,
    private ngZone: NgZone,
  ) {}

  ngAfterViewInit(): void {
    this.scrollContainer = this.el.nativeElement.querySelector('.p-datatable-table-container');

    if (!this.scrollContainer) return;

    this.ngZone.runOutsideAngular(() => {
      this.scrollContainer!.addEventListener('mousedown', this.onMouseDown);
      this.scrollContainer!.addEventListener('click', this.onClickCapture, true);
      document.addEventListener('mousemove', this.onMouseMove);
      document.addEventListener('mouseup', this.onMouseUp);
    });
  }

  ngOnDestroy(): void {
    if (this.scrollContainer) {
      this.scrollContainer.removeEventListener('mousedown', this.onMouseDown);
      this.scrollContainer.removeEventListener('click', this.onClickCapture, true);
    }
    document.removeEventListener('mousemove', this.onMouseMove);
    document.removeEventListener('mouseup', this.onMouseUp);
  }

  private handleMouseDown(e: MouseEvent): void {
    if (!this.scrollContainer) return;

    const target = e.target as HTMLElement;
    if (target.tagName === 'INPUT' || target.tagName === 'BUTTON' || target.tagName === 'SELECT') return;

    this.isDragging = true;
    this.hasMoved = false;
    this.startX = e.pageX;
    this.scrollLeft = this.scrollContainer.scrollLeft;
    this.scrollContainer.style.cursor = 'grabbing';
    this.scrollContainer.style.userSelect = 'none';
  }

  private handleMouseMove(e: MouseEvent): void {
    if (!this.isDragging || !this.scrollContainer) return;

    const deltaX = e.pageX - this.startX;

    if (!this.hasMoved && Math.abs(deltaX) > this.DRAG_THRESHOLD) {
      this.hasMoved = true;
    }

    if (this.hasMoved) {
      this.scrollContainer.scrollLeft = this.scrollLeft - deltaX;
    }
  }

  private handleMouseUp(): void {
    if (!this.scrollContainer) return;
    this.isDragging = false;
    this.scrollContainer.style.cursor = '';
    this.scrollContainer.style.userSelect = '';
  }

  private handleClickCapture(e: MouseEvent): void {
    if (this.hasMoved) {
      e.stopPropagation();
      e.preventDefault();
      this.hasMoved = false;
    }
  }
}
